import { makeStyles } from '@material-ui/core';
import { MDSTypography } from '@marqvision/mds-v2';
import { MDSChip, MDSChipGroup, MDSDivider } from '@marqvision/mds/core';
import { useAuth } from '~/apis/auth';
import { useProfile } from '~/apis/home';
import { MarqCommonEnumsClientBusinessType } from '~/swagger/data-contracts';
import FolioLogo from '../FolioLogo';

export const clientViewHeaderHeight = 48;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    height: clientViewHeaderHeight,
    backgroundColor: theme.color.bg.surface.inverse.light,
    position: 'relative',
    zIndex: 100,
    padding: '0 24px',
  },
}));

export const ClientViewHeader = () => {
  const classes = useStyles();

  const { data: authData } = useAuth();
  const { data } = useProfile();

  const name = data
    ? data.businessType === MarqCommonEnumsClientBusinessType.Individual
      ? data.ownerFirstName || data.ownerLastName
        ? `${data.ownerFirstName} ${data.ownerLastName}`
        : undefined
      : data.companyName
    : '';

  return (
    <div className={classes.root}>
      <FolioLogo color="white" scale={0.75} />
      <MDSDivider orientation="vertical" length={16} />
      <MDSTypography weight="medium" color="color/content/on_default_color">
        Client view
      </MDSTypography>
      <MDSChipGroup variant="tint" color="white" divider>
        <MDSChip variant="tint" color="white" label={`#${authData?.userId}`} />
        <MDSChip variant="tint" color="white" label={name || data?.email} />
      </MDSChipGroup>
    </div>
  );
};
